import React from "react";
import TopLabelCustomSelectBox from "../TopLabelReactSelect/TopLabelReactSelect";
import {
  MenteesNumbers,
  MentorShipModes,
  MentorShipRoles,
} from "../../utils/constants";

import styles from "./AcademicActivites.module.css";
import MentorshipSelect from "./MentorshipSelect";

const MentorLastRow = ({ register, control, errors, setValue, disabled }) => {
  return (
    <>
      <div className={styles.grid}>
        <TopLabelCustomSelectBox
          label="Number of Mentees You Can Support"
          name={`numberofMentees`}
          register={register}
          errors={errors}
          placeholder="Select"
          options={MenteesNumbers}
          control={control}
          disabled={disabled}
        />
        <TopLabelCustomSelectBox
          label="Preferred Mentorship Mode"
          name={`preferredMentorshipMode`}
          register={register}
          errors={errors}
          placeholder="Select"
          options={MentorShipModes}
          control={control}
          disabled={disabled}
        />
      </div>
      <MentorshipSelect
        label="Preferred Mentorship Role"
        name="preferredMentorshipRole"
        options={MentorShipRoles}
        control={control}
        errors={errors}
        setValue={setValue}
        disabled={disabled}
      />
    </>
  );
};

export default MentorLastRow;
